import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect } from 'react';
import { skipToken } from '@apollo/client';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import useModularPdp from 'global-state/modularPdp/useModularPdp';
import useSetModularPdp from 'global-state/modularPdp/useSetModularPdp';
import { GET_MODULAR_SOFA_BUNDLE } from './queries';
import { getBundleProductsWithOrientation } from './utils';
import useProductCardOptions from '../useProductCardOptions';
const useModularPDPState = (id, slug, t0) => {
  const $ = _c(46);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const queryOptions = t1;
  const {
    skip: t2,
    skipQuery: t3
  } = queryOptions;
  const skip = t2 === undefined ? false : t2;
  const skipQuery = t3 === undefined ? true : t3;
  const modularState = useModularPdp();
  const setModularPdp = useSetModularPdp();
  const userLocation = useUserLocation();
  const skipModularBundleQuery = skip || skipQuery;
  let t4;
  if ($[2] !== skipModularBundleQuery || $[3] !== slug || $[4] !== userLocation?.stateShortName || $[5] !== userLocation?.zip) {
    t4 = isNewConsumerApp && skipModularBundleQuery ? skipToken : {
      variables: {
        slug,
        zipCode: userLocation?.zip,
        ...getVisitorLocationQueryVariables(userLocation?.stateShortName)
      },
      skip: skipModularBundleQuery
    };
    $[2] = skipModularBundleQuery;
    $[3] = slug;
    $[4] = userLocation?.stateShortName;
    $[5] = userLocation?.zip;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    loading: modularBundleLoading,
    data: modularBundleData,
    error: modularBundleError
  } = useSuspenseQuery(GET_MODULAR_SOFA_BUNDLE, t4);
  let t5;
  if ($[7] !== skip) {
    t5 = {
      skip
    };
    $[7] = skip;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    data: optionsData
  } = useProductCardOptions(modularBundleData?.modularBundle?.modular_parent?.id, undefined, undefined, t5);
  let t6;
  if ($[9] !== setModularPdp) {
    t6 = isOpen => {
      setModularPdp(prevModularPdp => ({
        ...prevModularPdp,
        isModularAddProductSidebarOpen: isOpen
      }));
    };
    $[9] = setModularPdp;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const toggleAddProductsSidebar = t6;
  let t7;
  if ($[11] !== setModularPdp) {
    t7 = updatedOrder => {
      if (!updatedOrder) {
        return;
      }
      setModularPdp(prevModularPdp_0 => ({
        ...prevModularPdp_0,
        modularBundleOrderStatus: updatedOrder
      }));
    };
    $[11] = setModularPdp;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const updateModularOrderStatus = t7;
  let t8;
  if ($[13] !== setModularPdp) {
    t8 = updatedPrice => {
      setModularPdp(prevModularPdp_1 => ({
        ...prevModularPdp_1,
        modularTotalPrice: updatedPrice
      }));
    };
    $[13] = setModularPdp;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const updateModularOrderTotal = t8;
  let t9;
  if ($[15] !== setModularPdp) {
    t9 = updatedProduct => {
      setModularPdp(prevModularPdp_2 => {
        if (!updatedProduct || prevModularPdp_2?.currentModularGalleryProduct?.id === updatedProduct?.id) {
          return prevModularPdp_2;
        }
        return {
          ...prevModularPdp_2,
          currentModularGalleryProduct: updatedProduct
        };
      });
    };
    $[15] = setModularPdp;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const updateCurrentGalleryProduct = t9;
  let t10;
  if ($[17] !== setModularPdp || $[18] !== updateCurrentGalleryProduct) {
    t10 = sectionalProduct => {
      setModularPdp(prevModularPdp_3 => ({
        ...prevModularPdp_3,
        modularSectionalProduct: sectionalProduct
      }));
      updateCurrentGalleryProduct(sectionalProduct);
    };
    $[17] = setModularPdp;
    $[18] = updateCurrentGalleryProduct;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const setModularSectionalProduct = t10;
  let t11;
  if ($[20] !== modularBundleData || $[21] !== modularState?.modularSlug || $[22] !== optionsData.options || $[23] !== setModularPdp || $[24] !== skip) {
    t11 = () => {
      if (skip) {
        return;
      }
      if (modularBundleData?.modularBundle && optionsData?.options && modularState?.modularSlug !== modularBundleData?.modularBundle?.modular_parent?.slug) {
        const {
          modularBundle: t12
        } = modularBundleData;
        const {
          modular_parent,
          products,
          preConfiguredProducts
        } = t12;
        const collectionTitle = modular_parent?.name ? modular_parent.name.split(" ")[0] : "";
        const processedBundleProducts = getBundleProductsWithOrientation(products);
        setModularPdp(prevModularPdp_4 => ({
          ...prevModularPdp_4,
          modularParentSlug: modular_parent.slug,
          collectionTitle,
          preConfiguredProducts,
          bundleProducts: processedBundleProducts
        }));
      }
    };
    $[20] = modularBundleData;
    $[21] = modularState?.modularSlug;
    $[22] = optionsData.options;
    $[23] = setModularPdp;
    $[24] = skip;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const t12 = modularState?.modularSlug;
  let t13;
  if ($[26] !== modularBundleData || $[27] !== optionsData.options || $[28] !== setModularPdp || $[29] !== skip || $[30] !== t12) {
    t13 = [modularBundleData, t12, optionsData.options, setModularPdp, skip];
    $[26] = modularBundleData;
    $[27] = optionsData.options;
    $[28] = setModularPdp;
    $[29] = skip;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  useEffect(t11, t13);
  if (skip) {
    let t14;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = {};
      $[32] = t14;
    } else {
      t14 = $[32];
    }
    return t14;
  }
  let t14;
  if ($[33] !== modularState) {
    t14 = {
      modularState
    };
    $[33] = modularState;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== setModularSectionalProduct || $[36] !== toggleAddProductsSidebar || $[37] !== updateCurrentGalleryProduct || $[38] !== updateModularOrderStatus || $[39] !== updateModularOrderTotal) {
    t15 = {
      toggleAddProductsSidebar,
      updateModularOrderStatus,
      updateModularOrderTotal,
      setModularSectionalProduct,
      updateCurrentGalleryProduct
    };
    $[35] = setModularSectionalProduct;
    $[36] = toggleAddProductsSidebar;
    $[37] = updateCurrentGalleryProduct;
    $[38] = updateModularOrderStatus;
    $[39] = updateModularOrderTotal;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== modularBundleError || $[42] !== modularBundleLoading || $[43] !== t14 || $[44] !== t15) {
    t16 = {
      loading: modularBundleLoading,
      error: modularBundleError,
      data: t14,
      actions: t15
    };
    $[41] = modularBundleError;
    $[42] = modularBundleLoading;
    $[43] = t14;
    $[44] = t15;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  return t16;
};
export default useModularPDPState;